function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalInflowBaas({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#F0F6EF",
    style: {
      fill: "#F0F6EF",
      fill: "color(display-p3 0.9412 0.9647 0.9373)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4518 23.41C18.4518 24.5417 19.3268 25.4517 20.4001 25.4517H22.5934C23.5268 25.4517 24.2851 24.6584 24.2851 23.6667C24.2851 22.605 23.8185 22.22 23.1301 21.975L19.6184 20.75C18.9301 20.505 18.4635 20.1317 18.4635 19.0584C18.4635 18.0784 19.2218 17.2734 20.1551 17.2734H22.3484C23.4218 17.2734 24.2968 18.1834 24.2968 19.315",
    stroke: "#396C31",
    style: {
      stroke: "#396C31",
      stroke: "color(display-p3 0.2222 0.4235 0.1908)",
      strokeOpacity: 1
    },
    strokeWidth: 1.57895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3684 16.1184V26.6184",
    stroke: "#396C31",
    style: {
      stroke: "#396C31",
      stroke: "color(display-p3 0.2222 0.4235 0.1908)",
      strokeOpacity: 1
    },
    strokeWidth: 1.57895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0351 21.3684C33.0351 27.8084 27.8084 33.0351 21.3684 33.0351C14.9284 33.0351 9.70178 27.8084 9.70178 21.3684C9.70178 14.9284 14.9284 9.70172 21.3684 9.70172",
    stroke: "#396C31",
    style: {
      stroke: "#396C31",
      stroke: "color(display-p3 0.2222 0.4235 0.1908)",
      strokeOpacity: 1
    },
    strokeWidth: 1.57895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2018 10.8684V15.5351H31.8684",
    stroke: "#396C31",
    style: {
      stroke: "#396C31",
      stroke: "color(display-p3 0.2222 0.4235 0.1908)",
      strokeOpacity: 1
    },
    strokeWidth: 1.57895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0351 9.70172L27.2018 15.5351",
    stroke: "#396C31",
    style: {
      stroke: "#396C31",
      stroke: "color(display-p3 0.2222 0.4235 0.1908)",
      strokeOpacity: 1
    },
    strokeWidth: 1.57895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalInflowBaas);
export default __webpack_public_path__ + "static/media/total_inflow_baas.2e9efeca270f0eeb50c00ec54f9084f2.svg";
export { ForwardRef as ReactComponent };